export { default as ProductsIndexTable } from './ProductsIndexTable';
